import React from "react";
import themePropTypes from "../theme-prop-types";
import Text from "./text";
import Checkbox from "./checkbox";

const CellWithCheck = ({
  label,
  handleControlCheck,
  checked,
  name,
  ariaLabel
}) => (
  <div className='cell-with-check-wrapper-web-sdk'>
    <div className='cell-with-check-label-web-sdk'>
      <Text label={label} name={name} />
    </div>
    <div className='cell-with-check-checkbox-web-sdk'>
      <Checkbox
        name={name}
        onChange={handleControlCheck}
        checked={checked}
        aria-label={ariaLabel || label}
      />
    </div>
  </div>
);
CellWithCheck.propTypes = themePropTypes.cellWithCheck;

export default CellWithCheck;
